module.exports = __webpack_public_path__ + "img/verified.be0f3ffb.png";